import { render, staticRenderFns } from "./RecMysteryConfig.vue?vue&type=template&id=5181d528"
import script from "./RecMysteryConfig.vue?vue&type=script&lang=js"
export * from "./RecMysteryConfig.vue?vue&type=script&lang=js"
import style0 from "./RecMysteryConfig.vue?vue&type=style&index=0&id=5181d528&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports